export default class DeadAnimalInfoPage {
    constructor(number=0, species, notListedSpecies, marking, markingType, markingCodes, lat, lng, carcass, comments) {
        this.number = number;
        this.species = species;
        this.notListedSpecies = notListedSpecies;
        this.marking = marking;
        this.markingType = markingType;
        this.markingCodes = markingCodes;
        this.lat = lat;
        this.lng = lng;
        this.carcass = carcass;
        this.comments = comments;
    }
}